export default function AlertBlock({ type, children }) {
  const styles = {
    info: {
      bg: "bg-blue-800/10 dark:bg-blue-800/10",
      bar: "bg-blue-500 dark:bg-blue-400",
    },
    warn: {
      bg: "bg-yellow-800/10 dark:bg-yellow-800/10",
      bar: "bg-yellow-500 dark:bg-yellow-400",
    },
    error: {
      bg: "bg-red-800/10 dark:bg-red-800/10",
      bar: "bg-red-500 dark:bg-red-400",
    },
  }[type];

  return (
    <div
      className={`w-full min-h-16 border border-gray-200 dark:border-gray-700 rounded-2xl flex overflow-hidden ${styles.bg}`}
    >
      <div className={`w-3 ${styles.bar} rounded-l-2xl`} />

      <div className="flex-1 p-4 flex items-center">
        {children}
      </div>
    </div>
  );
}
